import { useContext, useEffect, useState } from 'react';
import { TransButtonLink, TransButtonPrimary } from '../../Atoms/Buttons';
import { EditableEmailProperty } from '../../Atoms/EditableProperties/EditableEmailProperty';
import { EmailContactListFormatter } from '../../Atoms/Formatter/EmailContactListFormatter';
import { EditableMultiAutocomplete } from '../../Atoms/inputs/EditableMultiAutocomplete';
import { patchDraft } from '../../Service/restapi/messageService';
import { fetchEventParticipations } from '../../Service/restapi/eventService';
import { fetchContacts, fetchContactsById } from '../../Service/restapi/contactService';
import { ContactFormatter } from '../../Atoms/Formatter/ContactFormatter';
import { MessageContext } from '../../Service/Context/MessageContext';
import { ContactS } from '../../Service/ContactS';
import { openEditContactModal } from '../Contact/EditContactModal';

export const EmailSuggestionListComponent = ({ suggestion }) => {
  const styles = {
    personDescription: {},
    email: {
      fontSize: 12,
    },
    openEdit: {
      fontSize: 12,
      fontStyle: 'italic',
    },
  };
  return (
    <div>
      <div>{suggestion.personDescription}</div>
      <div style={styles.email}>{suggestion.email}</div>
      {!suggestion.email && <div style={styles.openEdit}>Klick, um E-Mail hinzuzufügen</div>}
    </div>
  );
};

export default function ({ eventId }) {
  const [contacts, setContacts] = useState(undefined);
  const { message, changeMessage } = useContext(MessageContext);

  const [showCc, setShowCc] = useState(message && message.cc && message.cc.length > 0);
  const [showBcc, setShowBcc] = useState(message && message.bcc && message.bcc.length > 0);
  const [editingContact, setEditingContact] = useState(false);
  const [editContactId, setEditContactId] = useState();

  function loadContacts() {
    if (eventId) {
      fetchEventParticipations(eventId)
        .then((resp) => {
          if (resp.ok) {
            resp.json().then((participants) => {
              const contactIds = [];
              participants.forEach((p) => contactIds.push(p.contactId));
              fetchContactsById(contactIds)
                .then((resp) => {
                  if (resp.ok) {
                    resp.json().then((newContacts) => {
                      const contacts = [];
                      newContacts.forEach((c) => {
                        contacts.push({
                          contactId: c.id,
                          email: c.email,
                          personDescription: c.personDescription,
                        });
                      });
                      setContacts(contacts);
                    });
                  } else {
                    console.error('could not fetch contacts by Id-List');
                  }
                })
                .catch((error) => {
                  console.error({ error });
                  console.error('could not fetch contacts by Id-List');
                });
            });
          } else {
            console.error(`could not load participants of event ${eventId}`);
          }
        })
        .catch((error) => {
          console.error({ error });
          console.error(`could not load participants of event ${eventId}`);
        });
    } else {
      fetchContacts().then((resp) => {
        if (resp.ok) {
          resp.json().then((newContacts) => {
            const contacts = [];
            newContacts.forEach((c) => {
              contacts.push({
                contactId: c.id,
                email: c.email,
                personDescription: c.personDescription,
              });
            });
            setContacts(contacts);
          });
        }
      });
    }
  }

  useEffect(() => {
    loadContacts();
  }, []);

  useEffect(() => {
    if (message && message.cc && message.cc.length > 0) {
      setShowCc(true);
    }
    if (message && message.bcc && message.bcc.length > 0) {
      setShowBcc(true);
    }
  }, [message]);

  const styles = {
    emailAddress: {
      flex: 1,
    },
    receiver: {
      display: 'flex',
      marginBottom: 5,
      flexWrap: 'wrap',
    },
    receiverAddButtonLeft: {
      marginRight: 4,
    },
    receiverAddButtonRight: {
      marginLeft: 4,
    },
  };

  if (!message) {
    return null;
  }

  function filterSuggestions(suggestion, searchString) {
    if (!searchString) return true;

    if (
      suggestion &&
      suggestion.personDescription &&
      suggestion.personDescription.toLowerCase().indexOf(searchString.toLowerCase()) > -1
    ) {
      return true;
    }
    return suggestion.email && suggestion.email.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
  }

  function removeContact(val, patchField) {
    let receivers = message[patchField];
    if (receivers !== null) {
      receivers = receivers.filter((r) => r.email !== val.email);
      patchDraft(message.id, { [patchField]: receivers }).then((resp) => {
        if (resp.ok) {
          resp.json().then((newMessage) => {
            changeMessage(newMessage);
          });
        }
      });
    }
  }

  function searchContactWithoutEmail(patch) {
    patch.to.forEach((c) => {
      if (!c.email) {
        ContactS.fetchById(c.contactId).then((_contact) => {
          if (_contact) {
            openEditContactModal(
              _contact,
              () => loadContacts(),
              undefined,
              () => setEditingContact(false),
            );
          }
        });
      }
    });
    return patch;
  }

  return (
    <div>
      <div style={styles.receiver}>
        <TransButtonPrimary style={styles.receiverAddButtonLeft} onClickHandler={() => {}} text="An" />
        <div style={{ flex: 1, minWidth: 100 }}>
          <EditableEmailProperty
            patchField="to"
            preChange={searchContactWithoutEmail}
            remove={(val) => {
              removeContact(val, 'to');
            }}
            changeHandler={changeMessage}
            filterSuggestions={filterSuggestions}
            email={message}
            suggestions={contacts}
            listValueComponent={EmailSuggestionListComponent}
            editFormatter={EditableMultiAutocomplete}
            subPatchField="email"
            formatter={ContactFormatter}
            labelFormatter={EmailContactListFormatter}
          />
        </div>
        {!showCc && (
          <TransButtonLink
            className="primary-link"
            style={styles.receiverAddButtonRight}
            onClick={() => {
              setShowCc(true);
            }}
            text="Cc"
          />
        )}
        {!showBcc && (
          <TransButtonLink
            className="primary-link"
            style={styles.receiverAddButtonRight}
            onClick={() => {
              setShowBcc(true);
            }}
            text="Bcc"
          />
        )}
      </div>

      {showCc && (
        <div style={styles.receiver}>
          <TransButtonPrimary style={styles.receiverAddButtonLeft} onClickHandler={() => {}} text="Cc" />
          <div style={{ flex: 1, minWidth: 100 }}>
            <EditableEmailProperty
              patchField="cc"
              remove={(val) => {
                removeContact(val, 'cc');
              }}
              changeHandler={changeMessage}
              filterSuggestions={filterSuggestions}
              email={message}
              suggestions={contacts}
              listValueComponent={EmailSuggestionListComponent}
              editFormatter={EditableMultiAutocomplete}
              subPatchField="email"
              formatter={ContactFormatter}
              labelFormatter={EmailContactListFormatter}
            />
          </div>
        </div>
      )}

      {showBcc && (
        <div style={styles.receiver}>
          <TransButtonPrimary style={styles.receiverAddButtonLeft} onClickHandler={() => {}} text="Bcc" />
          <div style={{ flex: 1, minWidth: 100 }}>
            <EditableEmailProperty
              patchField="bcc"
              remove={(val) => {
                removeContact(val, 'bcc');
              }}
              changeHandler={changeMessage}
              filterSuggestions={filterSuggestions}
              email={message}
              suggestions={contacts}
              listValueComponent={EmailSuggestionListComponent}
              editFormatter={EditableMultiAutocomplete}
              subPatchField="email"
              formatter={ContactFormatter}
              labelFormatter={EmailContactListFormatter}
            />
          </div>
        </div>
      )}
    </div>
  );
}
